import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPosts();
    }, []);

    async function fetchPosts() {
        try {
            const apiUrl = '/api/blog/posts?limit=4';
            
            const response = await fetch(apiUrl);
            if (!response.ok) throw new Error('Backend not available');
            const data = await response.json();
            console.log('Blog posts fetched:', data.posts);
            setPosts(data.posts || []);
        } catch (error) {
            console.error('Error fetching blog posts:', error);
            setPosts([]);
        } finally {
            setLoading(false);
        }
    }

    // Show section even if no posts, with message
    if (loading) {
        return (
            <section id="blog" className="section blog">
                <div className="section-inner">
                    <h2 className="title title-h2">Insights &amp; <br/>Articles</h2>
                    <h3 className="subtitle subtitle-h3">Latest from the Blog</h3>
                    <p className="description">Loading latest posts...</p>
                </div>
            </section>
        );
    }

    return (
        <section id="blog" className="section blog">
            <div className="section-inner">
                <h2 className="title title-h2">Insights &amp; <br/>Articles</h2>
                <h3 className="subtitle subtitle-h3">Latest from the Blog</h3>
                <p className="description">Latest updates, tips, and guides on web development, digital marketing, and video content.</p>

                {posts.length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
                        No blog posts available yet. Check back soon!
                    </p>
                ) : (
                    <>
                        <div className="blog-list">
                            {posts.map((post) => (
                                <div className="blog-item" key={post._id}>
                                    {post.featuredImage && (
                                        <div className="blog-image">
                                            <img 
                                                src={post.featuredImage} 
                                                alt={post.title}
                                                loading="lazy"
                                                onError={(e) => {
                                                    console.error('Image failed to load:', post.featuredImage);
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div>
                                        <div className="blog-meta">
                                            <span className="category">{post.category}</span>
                                            <span className="date">{new Date(post.publishDate || post.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                        </div>
                                        <h3 className="blog-title">{post.title}</h3>
                                        <p className="blog-excerpt">{post.excerpt}</p>
                                        <Link className="btn btn-secondary" to={`/blog/${post.slug}`}>Read More</Link>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <Link to="/blog" className="btn btn-primary">View All Articles</Link>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default Blog;
